module.exports = __webpack_public_path__ + "static/media/event-services-img15.55929ba1.jpg";